var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlannerReview = function SvgPlannerReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.221 21.25 8.991 6.22 6.598 17.25H2.25v-1.5h3.142l2.816-13h1.58l3.262 15.185 2.133-9.185h1.625l1.8 7h3.142v1.5h-4.308l-1.411-5.527-2.214 9.527z"
  })));
};
export default SvgPlannerReview;